<template>
  <td>
    <i
      v-if="checked"
      class="fas fa-check text-success"
      v-tooltip:top="sendStartsAtTooltip"
    ></i>
    <div v-else>
      <div class="mb-2" v-html="dateTimeHtml"></div>
      <div>{{ time }}</div>
    </div>
  </td>
</template>

<script lang="babel">
import moment from "moment";
import { getDateTimeHtml } from '@/js/date';

export default {
    props: ['content', 'label', 'model', 'attribute'],
    data() {
      return {
        // working: null,
        time: null,
        intervalId: null,
        checked: false,
        dateTimeHtml: getDateTimeHtml(this.content)
      }
    },
    computed: {
      sendStartsAtTooltip() {
        return "versand gestartet am: " + this.dateTimeHtml;
      },
    },
    methods: {
      updateCountdown() {
        if (this.model[this.attribute.checkAttribute]) {
          clearInterval(this.intervalId);
          this.checked = true;
          return;
        }
        let diffTime = moment(this.content).diff(moment());

        if (diffTime < 0) {
          this.time = null;
          return;
        }

        let duration = moment.duration(diffTime, 'milliseconds');

        let countdown = "";

        if (duration.years() > 0) {
          countdown += duration.years() + " Jahr(e) ";
        }

        if (duration.months() > 0) {
          countdown += duration.months() + " Monat(e) ";
        }

        if (duration.days() > 0) {
          countdown += duration.days() + " Tag(e) ";
        }

        if (duration.hours() > 0) {
          countdown += duration.hours() > 9 ? duration.hours() + ":" : "0" + duration.hours() + ":";
        }

        countdown += duration.minutes() > 9 ? duration.minutes() + ":" : "0" + duration.minutes() + ":";
        countdown += duration.seconds() > 9 ? duration.seconds() : "0" + duration.seconds();

        this.time = countdown;
      }
    },
    created() {
      this.updateCountdown();
      if (!this.checked) {
        this.intervalId = setInterval(this.updateCountdown, 1000);
      }
    },
    destroyed() {
      clearInterval(this.intervalId);
    }
};
</script>
